import React from "react";
import { motion, AnimatePresence } from "framer-motion";
// import { useInView } from "react-intersection-observer";
import {
  FaHistory,
  FaAward,
  FaTools,
  FaTrophy,
  FaHandshake,
  FaChartLine
} from "react-icons/fa";
import { GiAchievement, GiGrowth } from "react-icons/gi";
import { RiTeamFill } from "react-icons/ri";

// Import images
import a1 from "../../Images/tata-award.jpg";
import a2 from "../../Images/turbo-award.jpg";
import a3 from "../../Images/2020-award.jpeg";
import a4 from "../../Images/2023-Fleetmanagement-award.jpeg";
import a5 from "../../Images/Exide-battery-award.jpeg";
import a6 from "../../Images/Highestsales-42-tonner-award.jpeg";
import a7 from "../../Images/sanketkumar.jpeg";
import Partners from "../Home/Partners";
import MilestoneTimeline from "./Milestone";

const AboutUs = () => {
  const awards = [
    {
      img: a1,
      title: "Best VME Realisation",
      description: "Discount Sales Growth in the South Zone"
    },
    {
      img: a2,
      title: "Turbo Excellence",
      description: "Best Performance Award for outstanding turbo sales and service 2022-23"
    },
    {
      img: a3,
      title: "Operational Excellence",
      description: "Best Performance in TATA Alert"
    },
    {
      img: a4,
      title: "Fleet Management",
      description: "Best Performance award for Fleet Management Service"
    },
    {
      img: a5,
      title: "Battery Partnership",
      description: "Best Performance award from Exide Battery"
    },
    {
      img: a6,
      title: "Sales Achievement",
      description: "Highest sales of TATA 42 Tonner Vehicles 2018-2019"
    },
    {
      img: a7,
      title: "Customer Service Excellence",
      description: "Sanket Kumar - Highest customer appreciations in South FY25"
    }
  ];

  return (
    <div className="bg-gradient-to-b from-blue-50 to-white text-justifyhome
    ">
      {/* Hero Section */}
      <section className="relative pt-20 pb-4 overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800">
        <div className="absolute inset-0  opacity-10" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div
            className="text-center"
          >
            <div className="mt-8 inline-flex items-center gap-2 mb-6 px-4 py-2 bg-blue-100 rounded-full text-blue-600 font-medium">
              <FaHandshake className="text-xl" />
              <span>Trusted Since 1973</span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold font-sans tracking-tight  bg-clip-text text-transparent bg-gradient-to-r from-white to-blue-200">
              Janatha group 
            </h1>
            <p className="mt-4 text-xl  bg-clip-text text-transparent bg-gradient-to-r from-white to-blue-200 max-w-3xl mx-auto">
              A journey of excellence, innovation, <br /> and customer trust, spanning over five decades
            </p>
          </div>
        </div>
      </section>

      {/* History Sections */}
      <section className="py-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Humble Beginnings */}
          <div
            className="bg-white rounded-2xl p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300"
          >
            <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center text-blue-600 mb-6">
              <FaTools className="text-2xl" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Humble Beginnings</h2>
            <p className="text-gray-600">
              Founded in 1973 by Late Gooty Dada Sab, Janatha Auto Works started as a small garage 
              in Gangavathi, offering quality repairs and services with a commitment to excellence.
            </p>
          </div>

          {/* Expansion & Achievements */}
          <div
            className="bg-white rounded-2xl p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300"
          >
            <div className="w-16 h-16 bg-yellow-100 rounded-xl flex items-center justify-center text-yellow-600 mb-6">
              <GiGrowth className="text-2xl" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Expansion & Achievements</h2>
            <p className="text-gray-600">
              By 2018, we became an authorized Tata Motors 3S dealership (Sales, Service, and Spares), 
              with presence across five strategic locations across North Karnataka and earning multiple industry awards.
            </p>
          </div>

          {/* Future Vision */}
          <div
            className="bg-white rounded-2xl p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300"
          >
            <div className="w-16 h-16 bg-green-100 rounded-xl flex items-center justify-center text-green-600 mb-6">
              <FaChartLine className="text-2xl" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Future Vision</h2>
            <p className="text-gray-600">
              Celebrating 50+ years of excellence, we continue to innovate and serve with the same 
              passion that built our foundation, embracing new technologies and customer needs.
            </p>
          </div>
        </div>
      </section>

      {/* Milestones Timeline */}
      <section className="py-16 bg-gradient-to-br from-gray-900 to-blue-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-16">
          <div
            className="text-center mb-12"
          >
            
            <h2 className="text-3xl md:text-4xl font-bold text-white">
              DISCOVER THE <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-blue-800">LEGACY AND GROWTH</span>
              {/* DISCOVER THE LEGACY AND GROWTH */}
            </h2>

            <p className="mt-3 text-lg text-gray-600 max-w-2xl mx-auto">
              Key milestones that shaped our growth and success
            </p>
          </div>
          <MilestoneTimeline />
        </div>
      </section>

      {/* Awards Section */}
      <section className="py-16 ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div
            className="text-center mb-12"
          >
            <div className="inline-flex items-center gap-2 mb-4">
              <FaTrophy className="text-blue-500 text-2xl" />
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                Awards & <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-blue-800">Recognitions</span>
              </h2>
            </div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Celebrating excellence and industry recognition
            </p>
          </div>

          <AnimatePresence>
              <div
                className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
              >
                {awards.map((award, index) => (
                  <div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300"
                  >
                    <div className="relative h-64 overflow-hidden">
                      <img
                        src={award.img}
                        alt={award.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                      <h3 className="text-xl font-bold mb-1">{award.title}</h3>
                      <p className="text-sm text-gray-300">{award.description}</p>
                      <div className="absolute top-4 right-4 w-10 h-10 bg-indigo-500 rounded-full flex items-center justify-center text-white">
                        <FaAward className="text-lg" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
          </AnimatePresence>
        </div>
      </section>

      {/* Partners Section */}
      <section className=" bg-gradient-to-br from-gray-900 to-blue-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Partners />
        </div>
      </section>
    </div>
  );
};

export default AboutUs;